import { CalculatorState } from "./types"

export function getFormattedValue(value: number) {
  return value.toLocaleString().replace(/,/g, " ")
}

export function formatNumber(number: number) {
  if (number >= 1000000) {
    return `${(number / 1000000).toFixed(0)} млн`
  }
  if (number >= 1000) {
    return `${(number / 1000).toFixed(0)} тыс.`
  }
  return number.toString()
}

function getYearWord(years: number): string {
  const lastDigit = years % 10
  const lastTwoDigits = years % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return "лет"
  if (lastDigit === 1) return "год"
  if (lastDigit >= 2 && lastDigit <= 4) return "года"
  return "лет"
}

export function getMonthWord(months: number): string {
  const lastDigit = months % 10
  const lastTwoDigits = months % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return "месяцев"
  if (lastDigit === 1) return "месяц"
  if (lastDigit >= 2 && lastDigit <= 4) return "месяца"
  return "месяцев"
}

export function formatLoanTerm(months: number): string {
  if (months < 1) return "Некорректный срок"

  if (months < 12) return `${months} ${getMonthWord(months)}`

  const years = Math.floor(months / 12)
  const remainingMonths = months % 12

  if (remainingMonths === 0) {
    return `${years} ${getYearWord(years)}`
  }

  return `${years} ${getYearWord(years)} ${remainingMonths} ${getMonthWord(remainingMonths)}`
}

export const calculateResult = (state: CalculatorState): CalculatorState => {
  if (state.mode === "cashback") {
    const getCashbackPercent = () => {
      if (state.halvaDesyatka) {
        return state.cashbackSum <= 9999 ? 0.04 : 0.1
      }
      return state.cashbackSum <= 9999 ? 0.02 : 0.05
    }

    const cashback = Math.min(
      state.cashbackSum * getCashbackPercent(),
      state.halvaDesyatka ? 5000 : 3000
    )

    return {
      ...state,
      paymentResult: parseFloat(cashback.toFixed(0)),
    }
  }
  const payment = state.installmentSum / state.term
  return {
    ...state,
    paymentResult: parseFloat(payment.toFixed(0)),
  }
}
